import { render, staticRenderFns } from "./_betting_rules.vue?vue&type=template&id=06787dfb&scoped=true&lang=pug&"
import script from "./_betting_rules.vue?vue&type=script&lang=js&"
export * from "./_betting_rules.vue?vue&type=script&lang=js&"
import style0 from "./_betting_rules.vue?vue&type=style&index=0&id=06787dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06787dfb",
  null
  
)

export default component.exports